export var ArticleStatus;
(function (ArticleStatus) {
    ArticleStatus[ArticleStatus["DRAFT"] = 0] = "DRAFT";
    ArticleStatus[ArticleStatus["PUBLISHED"] = 10] = "PUBLISHED";
    ArticleStatus[ArticleStatus["DELETED"] = 30] = "DELETED";
    ArticleStatus[ArticleStatus["DELETED_PERMANENTLY"] = 40] = "DELETED_PERMANENTLY";
})(ArticleStatus || (ArticleStatus = {}));
//# sourceMappingURL=article-status.enum.js.map